import React from 'react';
import { capitalizeFirstLetter, getStatusStyle } from '../../utils';
import './statusComponent.css';

/** Status label with coloured dot and optional tag (e.g. Partial). */
export default function StatusComponent({ status, statusTag, subStatus, emptyLabel = 'NA' }) {
  const tag = statusTag || (subStatus ? capitalizeFirstLetter(subStatus) : '');

  if (!status) {
    return (
      <div className="status-component">
        <div className="status-component__row">
          <i className="status-component__dot" style={getStatusStyle('NA')} />
          <span>{emptyLabel}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="status-component">
      <div className="status-component__row">
        <i className="status-component__dot" style={getStatusStyle(status)} />
        <span>{capitalizeFirstLetter(status)}</span>
      </div>
      {tag ? <span className="status-component-tag">{tag}</span> : null}
    </div>
  );
}
